import axios from './axios'

export const getPaymentMethods = async () => {
    try {
        return await axios.get(`/romons.payment/api/paymentmethods`)
    } catch (error) {
        throw error
    }
}

export const getBanks = async () => {
    try {
        return await axios.get(`/romons.payment/api/banks`)
    } catch (error) {
        throw error
    }
}

export const getBanksAccount = async () => {
    try {
        return await axios.get(`/romons.payment/api/banksaccount`)
    } catch (error) {
        throw error
    }
}

export const getBankTransactions = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/bank/transaction`, req)
    } catch (error) {
        throw error
    }
}

export const saveBank = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/bank/save`, req)
    } catch (error) {
        throw error
    }
}

export const updateOrderStatus = async (req) => {
    try {
        return await axios.put(`/romons.payment/api/updateorderstatus`, req)
    } catch (error) {
        throw error
    }
}

export const getPrice = async (gameCode, packageId, playerId, paymentCode) => {
    try {
        return await axios.get(`/romons.payment/api/getprice/${gameCode}/${packageId}/${playerId}/${paymentCode}`)
    } catch (error) {
        throw error
    }
}

export const confirmPrice = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/confirmprice`, req)
    } catch (error) {
        throw error
    }
}

export const confirmOrder = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/confirmorder`, req)
    } catch (error) {
        throw error
    }
}

export const getTimeLimit = async () => {
    try {
        return await axios.get(`/romons.payment/api/gettimelimit`)
    } catch (error) {
        throw error
    }
}

export const saveWalletTransaction = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/wallet/transaction/save`, req)
    } catch (error) {
        throw error
    }
}

export const updateWalletTransactionStatus = async (req) => {
    try {
        return await axios.patch(`/romons.payment/api/wallet/transaction/status`, req)
    } catch (error) {
        throw error
    }
}

export const changePin = async (req) => {
    try {
        return await axios.patch(`/romons.payment/api/wallet/changepin`, req)
    } catch (error) {
        throw error
    }
}

export const checkPin = async (pin) => {
    try {
        return await axios.get(`/romons.payment/api/wallet/pin/${pin}`)
    } catch (error) {
        throw error
    }
}

export const getWalletByid = async (id) => {
    try {
        return await axios.get(`/romons.payment/api/wallet/id/${id}`)
    } catch (error) {
        throw error
    }
}

export const getWalletByUid = async (uid) => {
    try {
        return await axios.get(`/romons.payment/api/wallet/uid/${uid}`)
    } catch (error) {
        throw error
    }
}

export const getWalletByKey = async (key) => {
    try {
        return await axios.get(`/romons.payment/api/wallet/key/${key}`)
    } catch (error) {
        throw error
    }
}

export const getWalletTransactionsByid = async (id) => {
    try {
        return await axios.get(`/romons.payment/api/wallet/transactions/id/${id}`)
    } catch (error) {
        throw error
    }
}

export const getWalletTransactionsByUid = async (uid) => {
    try {
        return await axios.get(`/romons.payment/api/wallet/transactions/uid/${uid}`)
    } catch (error) {
        throw error
    }
}

export const getWalletTransactions = async (data) => {
    try {
        return await axios.post(`/romons.payment/api/wallet/transactions`, data)
    } catch (error) {
        throw error
    }
}

export const getWalletStatus = async () => {
    try {
        return await axios.get(`/romons.payment/api/wallet/status`)
    } catch (error) {
        throw error
    }
}

export const getBenefitGameTopup = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/wallet/management/benefitgametopup`, req)
    } catch (error) {
        throw error
    }
}

export const saveBenefitGameTopup = async (req) => {
    try {
        return await axios.post(`/romons.payment/api/wallet/management/benefitgametopup/save`, req)
    } catch (error) {
        throw error
    }
}

export const MapSo = async (req) => {
    try {
        return await axios.patch(`/romons.payment/api/mapsalesorder`, req)
    } catch (error) {
        throw error
    }
}